import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useParams } from 'react-router-dom';
import ModalCollection from './ModalCollection';
import { CardList } from 'react-bootstrap-icons';
import { Placeholder } from 'react-bootstrap';

export default function CollectionButtons(props) {
	const { apiService, setShowMetadata } = props;
	const [showCol, setShowCol] = useState(false);
	const handleShowCol = () => setShowCol(true);
	let { isadg } = useParams();
	const [xmlDoc, setXmlDoc] = useState(null);
	const [IsadgMetadata, setIsadgMetadata] = useState({
		isLoading: false,
		payload: {},
	});
	useEffect(() => {
		try {
			setIsadgMetadata({ isLoading: true, payload: {} });
			apiService.getItemResume({}, { isadg: isadg }, (_, rdata) => {
				//console.log(rdata);
				setIsadgMetadata({ isLoading: false, payload: rdata });
				setShowMetadata((prevState) => ({
					...prevState,
					metadata: rdata.metadata,
					payload: rdata,
				}));
			});
		} catch (e) {
			//console.log(e);
			setIsadgMetadata({ isLoading: false, payload: {} });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [apiService, isadg]);

	/* useEffect(() => {
        window.scrollTo(0, 0);
    }, []); */

	useEffect(() => {
		if (IsadgMetadata?.payload) {
			let parser = new DOMParser();
			setXmlDoc(
				parser.parseFromString(
					IsadgMetadata.payload.metadata,
					'application/xml'
				)
			);
		}
	}, [IsadgMetadata]);

	//console.log('DATA', IsadgMetadata);
	return (
		<div className='c-top-btns'>
			{IsadgMetadata.isLoading && (
				<div className='c-more-info-btn'>
					<Placeholder.Button xs={6} />
					<Placeholder.Button xs={6} />
				</div>
			)}
			{!IsadgMetadata.isLoading && IsadgMetadata.payload && xmlDoc && (
				<>
					<Button className='c-more-info-btn' onClick={handleShowCol}>
						<CardList /> MAS INFORMACION
					</Button>

					<ModalCollection
						show={showCol}
						setShow={setShowCol}
						apiService={apiService}
						metadata={IsadgMetadata?.payload?.metadata}
						display_name={
							IsadgMetadata?.payload?.isadg?.display_name
						}
						digitalfile={IsadgMetadata.payload?.portada}
						xmlDoc={xmlDoc}
					/>
				</>
			)}
		</div>
	);
}
